export const SUPPORTED_LANGS = ["en", "es"] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];
export const FALLBACK_LANG: Lang = "en";

export const STORAGE_KEY = "acruxsoft.lang";

function normalize(raw: string | null | undefined): Lang | null {
  if (!raw) return null;
  const code = raw.slice(0, 2).toLowerCase();
  return (SUPPORTED_LANGS as readonly string[]).includes(code) ? (code as Lang) : null;
}

export function resolveInitialLang(opts: {
  searchParam: string | null;
  storedLang: string | null;
  navigatorLang: string;
}): Lang {
  return (
    normalize(opts.searchParam) ??
    normalize(opts.storedLang) ??
    normalize(opts.navigatorLang) ??
    FALLBACK_LANG
  );
}

export function readStoredLang(): Lang | null {
  if (typeof localStorage === "undefined") return null;
  return normalize(localStorage.getItem(STORAGE_KEY));
}

export function writeStoredLang(lang: Lang): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(STORAGE_KEY, lang);
}
